import React from 'react';
import {Avatar, List} from 'antd';
import styles from "./CenterListItem.module.scss";

interface CenterListItemProps {
    avatarURL: string
    title: string
    description?: string
    avatarSize?: number
    tail?: React.ReactElement
    itemStyle?: any
    detailStyle?: any
}

const { Item } = List

export const CenterListItem: React.FunctionComponent<CenterListItemProps> = ({
    avatarURL,
    title,
    description,
    avatarSize= 68,
    itemStyle,
    detailStyle,
    tail,
}) => {
    return (
        <Item style={itemStyle}>
            <div className={styles.ListContainer}>
                <div>
                    <Avatar src={avatarURL} size={avatarSize}/>
                </div>
                <div style={detailStyle} className={styles.ListDetailContainer}>
                    <div className={styles.ListDetailCon}>
                        <span className={styles.ListTitle}>{title}</span>
                        { description && <span className={styles.ListDescription}>{description}</span>}
                    </div>
                    {tail &&
                        <div className={styles.ListTailContainer}>
                            {tail}
                        </div>
                    }
                </div>
            </div>
        </Item>
    )
}